import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { DispatchExutoireDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-dispatch-exutoire-select',
  templateUrl: './dispatch-exutoire-select.component.html',
  styleUrls: ['./dispatch-exutoire-select.component.css']
})
export class DispatchExutoireSelectComponent implements OnInit {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.dispatchExutoires$) dispatchExutoires$: Observable<DispatchExutoireDto[]>;

  @Input() width: number;

  @Input() dispatchExutoireId: number;
  @Output() dispatchExutoireIdChange = new EventEmitter<number>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  DispatchExutoires: DispatchExutoireDto[] = [];
  SelectedDispatchExutoire: DispatchExutoireDto = null;
  ColumnName = [];

  de: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Identifiant'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations['Identifiant']);
    });
  }

  ngOnInit() {
    if (this.dispatchExutoireId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.dispatchExutoireId));
    }

    this.de = this.dispatchExutoires$.subscribe(res => {
      if (res != null) {
        this.DispatchExutoires = res;
      }
    });
  }

  ngOnDestroy() {
    this.de?.unsubscribe();
  }

  updateInfo(event) {
    this.dispatchExutoireId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.dispatchExutoireId;
    if (!!this.cell && this.InitId !== this.dispatchExutoireId) {
      this.cell.setValue(this.dispatchExutoireId);
    }
    this.dispatchExutoireIdChange.emit(this.dispatchExutoireId);

    if(this.dispatchExutoireId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.dispatchExutoireId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}
